// Countdown timer: each visitor's end time is kept in their browser, so reloading does not restart it.
if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', class extends HTMLElement {
    connectedCallback() {
      this.duration = Number(this.dataset.duration) * 1000;
      this.key = `countdown:${this.dataset.id}:${this.dataset.duration}`;
      this.numbers = Object.fromEntries([...this.querySelectorAll('[data-unit]')].map((el) => [el.dataset.unit, el]));
      if (!this.duration) return;
      this.end = this.readEnd() || this.newEnd();
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    readEnd() {
      try { return Number(localStorage.getItem(this.key)) || 0; } catch (error) { return 0; }
    }

    newEnd() {
      const end = Date.now() + this.duration;
      try { localStorage.setItem(this.key, String(end)); } catch (error) { /* private mode: the timer still runs for this visit */ }
      return end;
    }

    tick() {
      let left = this.end - Date.now();
      if (left <= 0) {
        if (this.dataset.end === 'restart') {
          this.end = this.newEnd();
          left = this.duration;
        } else {
          left = 0;
          clearInterval(this.timer);
          this.finish();
        }
      }
      const total = Math.floor(left / 1000);
      const parts = { days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
      if (!this.numbers.days) parts.hours += parts.days * 24;
      if (!this.numbers.hours) parts.minutes += parts.hours * 60;
      const pad = this.dataset.leadingZero === 'true';
      Object.entries(this.numbers).forEach(([unit, el]) => { el.textContent = pad ? String(parts[unit]).padStart(2, '0') : String(parts[unit]); });
    }

    finish() {
      this.classList.add('is-ended');
      if (this.dataset.end === 'message') this.querySelector('.countdown-timer__message')?.removeAttribute('hidden');
      if (this.dataset.end === 'hide' && !window.Shopify?.designMode) (this.closest('[data-countdown-hide-target]') || this.closest('.shopify-section'))?.setAttribute('hidden', '');
    }
  });
}
